/* eslint-disable no-confusing-arrow */
const calcPagesCount = (pageSize, totalCount) =>
    totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);

export { calcPagesCount };
